import NavFooter from './NavFooter.vue';
import NavHeader from './NavHeader.vue';

import ListPagination from '@/components/ListPagination.vue';
import RegionTree from '@/components/RegionTree.vue';
import FileUpload from "@/components/FileUpload.vue"
import UserList from "@/components/UserList.vue"
import QrCode from "@/components/QrCode.vue"
import UeEditor from "@/components/UeEditor.vue"
import NaviMap from "@/components/NaviMap.vue"
import ProfessionalTree from "@/components/ProfessionalTree.vue"
import KnowledgeProfessional from "@/components/KnowledgeProfessional.vue"
import QuestionTypes from "@/components/QuestionTypes.vue"
import QuestionTags from "@/components/QuestionTags.vue"
import KnowledgeList from "@/components/KnowledgeList.vue"
import FileView from "@/components/FileView.vue"
import SingleQuestion from "@/components/SingleQuestion.vue"
import QuestionEdit from "@/components/QuestionEdit.vue"
import QuestionEditModel from "@/components/QuestionEditModel.vue"
import PaperTypes from "@/components/PaperTypes.vue"
import PaperLevels from "@/components/PaperLevels.vue"
// import SelectQuestion from "@/components/SelectQuestion.vue"
// import ChapterTree from "@/components/ChapterTree.vue"
// import KnowledgeTree from "@/components/KnowledgeTree.vue"
import PaperView from "@/components/PaperView.vue"
import IndustryList from "@/components/IndustryList.vue"
import LaunchTask from "./LaunchTask.vue"
import AdvancedModal from "./AdvancedModal.vue"
import MajorCascader from "@/components/MajorCascader.vue"
import ClazzList from "./ClazzList.vue"
import IndustryTree from "@/components/IndustryTree.vue"
import PaperGroup from "@/components/PaperGroup.vue"
import PaperCascader from "@/components/PaperCascader.vue"
import SourceList from '@/components/SourceList.vue';
import PaperAuthCascader from "./PaperAuthCascader.vue"
import PaperList from "./PaperList.vue"
import VariantCascader from "@/components/VariantCascader.vue"
import ProfessionalList from "./ProfessionalList.vue"

const components = {
    install: function (Vue) {
        Vue.component('NavHeader', NavHeader);
        Vue.component('NavFooter', NavFooter);
        Vue.component('ListPagination', ListPagination);
        Vue.component('RegionTree', RegionTree);
        Vue.component('FileUpload', FileUpload);
        Vue.component('QrCode', QrCode);
        Vue.component('UserList', UserList);
        Vue.component('UeEditor', UeEditor);
        Vue.component('NaviMap', NaviMap);
        Vue.component('ProfessionalTree', ProfessionalTree);
        Vue.component('KnowledgeProfessional', KnowledgeProfessional);
        Vue.component('QuestionTypes', QuestionTypes);
        Vue.component('QuestionTags', QuestionTags);
        Vue.component('KnowledgeList', KnowledgeList);
        Vue.component('FileView', FileView);
        Vue.component('SingleQuestion', SingleQuestion);
        Vue.component('QuestionEdit', QuestionEdit);
        Vue.component('QuestionEditModel', QuestionEditModel);
        Vue.component('PaperTypes', PaperTypes);
        Vue.component('PaperLevels', PaperLevels);
        // Vue.component('SelectQuestion', SelectQuestion);
        // Vue.component('ChapterTree', ChapterTree);
        // Vue.component('KnowledgeTree', KnowledgeTree);
        Vue.component('PaperView', PaperView);
        Vue.component('IndustryList', IndustryList);
        Vue.component('LaunchTask', LaunchTask);
        Vue.component('AdvancedModal', AdvancedModal);
        Vue.component('MajorCascader', MajorCascader);
        Vue.component('ClazzList', ClazzList);
        Vue.component('IndustryTree', IndustryTree);
        Vue.component('PaperGroup', PaperGroup);
        Vue.component('PaperCascader', PaperCascader);
        Vue.component('SourceList', SourceList);
        Vue.component('PaperAuthCascader', PaperAuthCascader);
        Vue.component('PaperList', PaperList);
        Vue.component('VariantCascader', VariantCascader);
        Vue.component('ProfessionalList', ProfessionalList);
    }
}

export default components;


// WEBPACK FOOTER //
// ./src/pages/pc/components/shared/high-components.js